export const isValidDomain = (value) =>
  /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*$/.test(value);

export const isValidTimeFormat = (value) =>
  /^([0-1]?[0-9]|2[0-3]):[0-5][0-9](:00)?$/.test(value);
